var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-container"},[(_vm.stateVisible && _vm.message)?_c('div',{class:['alert', _vm.type, 'alert-dismissible'],attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('span',{staticClass:"close-btn",on:{"click":_vm.close}},[_vm._v("×")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }